import Dropdown from '@ps/payscale-design/lib/dropdown';
import '@ps/payscale-design/lib/dropdown/style/index.scss';

export interface PXLDropdownType {
    toggle: () => void;
}

export { Dropdown as PXLDropdown};
export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/PXL/pxlDropdown.ts